import Carousel from "../Carousel/Carousel";
import Rating from "../Rating/Rating";

function AccomodationHeader(props) {
  return (
    <header className="accomodation-page__header">
      <Carousel
        pictures={props.pictures}
        carouselLength={props.carouselLength}
      />

      <div className="container container--information information">
        <div className="information__main">
          <h1 className="information__main__title">{props.title}</h1>
          <h2 className="information__main__location">{props.location}</h2>

          <div className="information__main__tags">
            {props.tags.map((tag, key = 0) => {
              key++;
              return (
                <span className="information__main__tags__item" key={key}>
                  {tag}
                </span>
              );
            })}
          </div>
        </div>

        <div className="information__extra">
          <div className="information__extra__host">
            <h2 className="information__extra__host__name">{props.hostName}</h2>

            <div className="image-wrapper">
              <img src={props.hostPicture} alt=" "></img>
            </div>
          </div>

          <Rating rating={props.rating} />
        </div>
      </div>
    </header>
  );
}

export default AccomodationHeader;
